export function roundPercentage(value: number): number {
  return Math.round(value * 10) / 10
}

export function percentagesEqual(a: number, b: number, tolerance = 0.01): boolean {
  return Math.abs(a - b) < tolerance
}

export function isComplete(total: number): boolean {
  return percentagesEqual(total, 100)
}

export function distributePercentageEqually(
  percentageToDistribute: number,
  numberOfBeneficiaries: number,
  existingPercentages: number[],
): number[] {
  if (numberOfBeneficiaries === 0) return []

  const equalShare = percentageToDistribute / numberOfBeneficiaries
  const newPercentages = existingPercentages.map((existing) => roundPercentage(existing + equalShare))

  const total = newPercentages.reduce((sum, p) => sum + p, 0)

  if (!percentagesEqual(total, 100)) {
    const difference = roundPercentage(100 - total)
    newPercentages[newPercentages.length - 1] = roundPercentage(newPercentages[newPercentages.length - 1]! + difference)
  }

  return newPercentages
}

export function normalizePercentages(percentages: number[]): number[] {
  if (percentages.length === 0) return []

  const total = percentages.reduce((sum, p) => sum + p, 0)

  if (percentagesEqual(total, 100)) {
    return percentages
  }

  const normalized = percentages.map((p) => roundPercentage((p / total) * 100))

  const normalizedTotal = normalized.reduce((sum, p) => sum + p, 0)

  if (!percentagesEqual(normalizedTotal, 100)) {
    const difference = roundPercentage(100 - normalizedTotal)
    normalized[normalized.length - 1] = roundPercentage(normalized[normalized.length - 1]! + difference)
  }

  return normalized
}
